<template>
  <div class="filtro-periodo-badges-wrapper">
    <div class="filtro-pill-bar shadow-sm">
      <!-- Badges de Período Rápido -->
      <div class="periodo-badges-group">
        <button
          v-for="p in listaPeriodos"
          :key="'badge-p-' + p.key"
          type="button"
          class="badge-periodo-btn"
          :class="{ active: periodoSelecionado === p.key || periodoSelecionado === p.dias }"
          @click="selecionarPeriodo(p)"
          :title="'Filtrar por ' + p.label"
        >
          <svg v-if="p.key === 'hoje' || p.dias === 0" class="badge-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <svg v-else-if="p.key === 'ontem'" class="badge-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 8 14"></polyline>
          </svg>
          <svg v-else class="badge-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          <span>{{ p.label }}</span>
        </button>
      </div>

      <!-- Inputs de Data Integrados (Opcional via prop) -->
      <template v-if="incluirInputsData">
        <div class="filtro-divider"></div>

        <!-- Input DE -->
        <div class="data-input-item">
          <span class="data-input-label">DE:</span>
          <input
            type="date"
            :value="localDataDe"
            @change="onDataDeChange($event.target.value)"
            class="filtro-date-picker"
            title="Data Inicial"
          />
        </div>

        <div class="filtro-divider"></div>

        <!-- Input ATÉ -->
        <div class="data-input-item">
          <span class="data-input-label">ATÉ:</span>
          <input
            type="date"
            :value="localDataAte"
            @change="onDataAteChange($event.target.value)"
            class="filtro-date-picker"
            title="Data Final"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "FiltroPeriodoBadges",
  props: {
    dataDe: {
      type: String,
      default: ""
    },
    dataAte: {
      type: String,
      default: ""
    },
    periodoAtivo: {
      type: [String, Number],
      default: null
    },
    incluirInputsData: {
      type: Boolean,
      default: true
    },
    syncUrl: {
      type: Boolean,
      default: true
    },
    direcao: {
      type: String,
      default: "past" // 'past' (últimos N dias) ou 'future' (próximos N dias)
    },
    ateOntem: {
      type: Boolean,
      default: false // Se true, períodos passados (7d, 15d, 30d, 60d) terminam em ontem (hoje - 1), pegando apenas vencidos
    },
    modoVencidos: {
      type: Boolean,
      default: false
    },
    periodos: {
      type: Array,
      default: () => [
        { label: "Ontem", dias: 1, key: "ontem" },
        { label: "7d", dias: 7, key: "7d" },
        { label: "15d", dias: 15, key: "15d" },
        { label: "30d", dias: 30, key: "30d" },
        { label: "60d", dias: 60, key: "60d" },
        { label: "Hoje", dias: 0, key: "hoje" }
      ]
    }
  },
  data() {
    return {
      periodoSelecionado: this.periodoAtivo,
      localDataDe: this.dataDe,
      localDataAte: this.dataAte
    };
  },
  computed: {
    listaPeriodos() {
      return this.periodos && this.periodos.length > 0
        ? this.periodos
        : [
            { label: "Ontem", dias: 1, key: "ontem" },
            { label: "7d", dias: 7, key: "7d" },
            { label: "15d", dias: 15, key: "15d" },
            { label: "30d", dias: 30, key: "30d" },
            { label: "60d", dias: 60, key: "60d" },
            { label: "Hoje", dias: 0, key: "hoje" }
          ];
    }
  },
  watch: {
    dataDe(val) {
      this.localDataDe = val;
    },
    dataAte(val) {
      this.localDataAte = val;
    },
    periodoAtivo(val) {
      this.periodoSelecionado = val;
    }
  },
  mounted() {
    if (this.syncUrl) {
      this.carregarFiltrosDaUrl();
    }
  },
  methods: {
    carregarFiltrosDaUrl() {
      const q = this.$route ? this.$route.query : null;
      if (!q) return;

      let mudou = false;
      let novaDataDe = this.localDataDe;
      let novaDataAte = this.localDataAte;
      let novoPeriodo = this.periodoSelecionado;

      if (q.dataDe && q.dataDe !== this.localDataDe) {
        novaDataDe = q.dataDe;
        mudou = true;
      }
      if (q.dataAte && q.dataAte !== this.localDataAte) {
        novaDataAte = q.dataAte;
        mudou = true;
      }
      if (q.periodo !== undefined && q.periodo !== null) {
        novoPeriodo = q.periodo;
        mudou = true;
      }

      if (mudou) {
        this.localDataDe = novaDataDe;
        this.localDataAte = novaDataAte;
        this.periodoSelecionado = novoPeriodo;

        this.$emit("update:dataDe", novaDataDe);
        this.$emit("update:dataAte", novaDataAte);
        this.$emit("update:periodoAtivo", novoPeriodo);
        this.$emit("change", {
          dataDe: novaDataDe,
          dataAte: novaDataAte,
          periodo: novoPeriodo
        });
      }
    },

    sincronizarComUrl(dataDe, dataAte, periodo) {
      if (!this.syncUrl || !this.$router || !this.$route) return;

      const novaQuery = Object.assign({}, this.$route.query);
      if (dataDe) novaQuery.dataDe = dataDe;
      else delete novaQuery.dataDe;

      if (dataAte) novaQuery.dataAte = dataAte;
      else delete novaQuery.dataAte;

      if (periodo !== null && periodo !== undefined) novaQuery.periodo = periodo;
      else delete novaQuery.periodo;

      this.$router.push({ query: novaQuery }).catch(() => {});
    },

    selecionarPeriodo(p) {
      this.periodoSelecionado = p.key;
      const hoje = new Date();
      let de = new Date();
      let ate = new Date();

      if (p.key === "hoje" || (p.dias === 0 && p.key !== "ontem")) {
        // Hoje
        de = new Date(hoje);
        ate = new Date(hoje);
      } else if (p.key === "ontem") {
        // Apenas Ontem (1 dia atrás)
        de = new Date(hoje);
        de.setDate(hoje.getDate() - 1);
        ate = new Date(hoje);
        ate.setDate(hoje.getDate() - 1);
      } else if (this.direcao === "future") {
        // Próximos N dias
        de = new Date(hoje);
        ate.setDate(hoje.getDate() + p.dias);
      } else {
        // Últimos N dias
        de.setDate(hoje.getDate() - p.dias);
        if (this.ateOntem || this.modoVencidos) {
          // Pega apenas faturas vencidas (de ontem para trás, sem incluir o dia de hoje)
          ate.setDate(hoje.getDate() - 1);
        } else {
          ate = new Date(hoje);
        }
      }

      const dataDeStr = this.formatDataISO(de);
      const dataAteStr = this.formatDataISO(ate);

      this.localDataDe = dataDeStr;
      this.localDataAte = dataAteStr;

      this.$emit("update:dataDe", dataDeStr);
      this.$emit("update:dataAte", dataAteStr);
      this.$emit("update:periodoAtivo", p.key);

      this.sincronizarComUrl(dataDeStr, dataAteStr, p.key);

      this.$emit("change", {
        dataDe: dataDeStr,
        dataAte: dataAteStr,
        periodo: p.key,
        dias: p.dias
      });
    },

    onDataDeChange(val) {
      this.localDataDe = val;
      this.periodoSelecionado = "custom";

      this.$emit("update:dataDe", val);
      this.$emit("update:periodoAtivo", "custom");

      this.sincronizarComUrl(val, this.localDataAte, "custom");

      this.$emit("change", {
        dataDe: val,
        dataAte: this.localDataAte,
        periodo: "custom"
      });
    },

    onDataAteChange(val) {
      this.localDataAte = val;
      this.periodoSelecionado = "custom";

      this.$emit("update:dataAte", val);
      this.$emit("update:periodoAtivo", "custom");

      this.sincronizarComUrl(this.localDataDe, val, "custom");

      this.$emit("change", {
        dataDe: this.localDataDe,
        dataAte: val,
        periodo: "custom"
      });
    },

    formatDataISO(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
  }
};
</script>

<style scoped>
.filtro-periodo-badges-wrapper {
  display: inline-flex;
  align-items: center;
  margin: 0;
}

.filtro-pill-bar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0 6px;
  height: 34px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.periodo-badges-group {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  background: #f8fafc;
  padding: 2px 3px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.badge-periodo-btn {
  background: transparent;
  border: none;
  padding: 3px 6px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.badge-periodo-btn:hover {
  color: #0f172a;
  background: #f1f5f9;
}

.badge-periodo-btn.active {
  background: #0f172a;
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.15);
}

.badge-icon {
  opacity: 0.8;
}

.badge-periodo-btn.active .badge-icon {
  opacity: 1;
}

.filtro-divider {
  width: 1px;
  height: 18px;
  background: #e2e8f0;
}

.data-input-item {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.data-input-label {
  font-size: 9.5px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
}

.filtro-date-picker {
  border: none;
  outline: none;
  font-size: 11px;
  font-weight: 600;
  color: #0f172a;
  background: transparent;
  padding: 1px 2px;
  cursor: pointer;
  width: 108px;
}

.filtro-date-picker:focus {
  background: #f8fafc;
  border-radius: 4px;
}
</style>
